const indexData = [
  { title: '明星八卦专区', desc: '最新娱乐动态追踪', icon: 'ri-star-smile-line', color: 'bg-primary-100 text-primary-600' },
  { title: '社会热点讨论', desc: '时事新闻深度解读', icon: 'ri-global-line', color: 'bg-accent-100 text-accent-600' },
  { title: '综艺节目交流', desc: '热门综艺畅聊天地', icon: 'ri-tv-2-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '影视剧评小组', desc: '新剧老剧一网打尽', icon: 'ri-film-line', color: 'bg-primary-100 text-primary-600' },
  { title: '情感互助专区', desc: '倾诉心声温暖陪伴', icon: 'ri-heart-2-line', color: 'bg-accent-100 text-accent-600' },
  { title: '数码科技前沿', desc: '科技资讯一手掌握', icon: 'ri-computer-line', color: 'bg-secondary-100 text-secondary-600' },
  { title: '美食种草拔草', desc: '吃货聚集分享美味', icon: 'ri-restaurant-2-line', color: 'bg-primary-100 text-primary-600' },
  { title: '旅行攻略分享', desc: '诗和远方都在这里', icon: 'ri-map-pin-line', color: 'bg-accent-100 text-accent-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-secondary-100">
            <i className="ri-grid-line text-secondary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">专题索引</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">探索吃瓜网51全部话题版块，找到你的兴趣圈</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <span className={`w-11 h-11 flex items-center justify-center rounded-xl shrink-0 ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div className="min-w-0">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}